import { Product } from "../../../utils/types";

export function normalizeProducts(data: unknown): Product[] {
  if (Array.isArray(data)) {
    return data as Product[];
  }

  if (
    data &&
    typeof data === "object" &&
    Array.isArray((data as { products?: unknown }).products)
  ) {
    return (data as { products: Product[] }).products;
  }

  return [];
}
